<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 justify-center>
        <v-card class="dash_card" style="border-radius: 12px;">
          <v-card-title class="headline font-weight-bold">
            Your profile
          </v-card-title>
          <v-card-text>
            Access and change information about you
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text v-on:click="profile_click"
              >Go to profile<v-icon right>arrow_forward</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card class="dash_card" style="border-radius: 12px;">
          <v-card-title class="headline font-weight-bold">
            Your Products
          </v-card-title>
          <v-card-text>
            Access your vetvise products
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text v-on:click="products_click"
              >Go to products<v-icon right>arrow_forward</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex></v-layout
    ></v-container
  >
</template>

<script>
export default {
  components: {},
  methods: {
    profile_click() {
      this.$router.push("profile");
    },
    products_click() {
      this.$router.push("products");
    }
  }
};
</script>

<style scoped>
.dash_card {
  border-radius: 12px;
  margin: 16px;
}
</style>
